import { render } from "./sms-gateway-modal.vue?vue&type=template&id=cfb0e84a"
import script from "./sms-gateway-modal.vue?vue&type=script&lang=js"
export * from "./sms-gateway-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__